export const normalizeOptionalStrings = (values: unknown, length: number) => {
  if (!Array.isArray(values)) {
    return undefined;
  }

  const normalized = Array.from({ length }, (_, index) => {
    const value = values[index];
    return typeof value === 'string' ? value.trim() : '';
  });
  return normalized.some(Boolean) ? normalized : undefined;
};
